import { AppState } from '../index';

export const getErrorMessage = (state: AppState) => state.appMessages.errorMessage.message;
export const getProgressMessage = (state: AppState) => state.appMessages.progressMessage.message;
